import { render, staticRenderFns } from "./ImportDialogWidget.vue?vue&type=template&id=a25ba4f6&"
import script from "./ImportDialogWidget.vue?vue&type=script&lang=js&"
export * from "./ImportDialogWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QForm,QUploader,QMarkupTable,QSelect,QCardActions,QBtn,QToggle,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QForm,QUploader,QMarkupTable,QSelect,QCardActions,QBtn,QToggle,QInput})
